import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_delivery_truck: SvgIconData = {
  viewBox: '4.32 23.52 91.36 52.95',
  element: (
    <g>
      <path d="M95.45 49.37 83.6 29.91a1.6 1.6 0 0 0-1.34-.75H68.99v-4.07c0-.87-.7-1.57-1.56-1.57h-42.3a1.56 1.56 0 1 0 0 3.13h40.74v37.88H43.19a10.05 10.05 0 0 0-19.72 0h-7.46a1.56 1.56 0 1 0 0 3.13h7.4c.6 4.95 4.8 8.82 9.92 8.82s9.31-3.87 9.93-8.82h23.65a10.02 10.02 0 0 0 19.79 0h7.42c.86 0 1.56-.7 1.56-1.57V50.2q0-.45-.23-.82M33.33 73.35a6.93 6.93 0 1 1 .01-13.86 6.93 6.93 0 0 1-.01 13.86m48.06-41.07 6.04 9.93H68.98v-9.93zm-4.6 40.74a6.93 6.93 0 1 1 .02-13.86 6.93 6.93 0 0 1-.01 13.86m15.77-8.49H86.7a10.04 10.04 0 0 0-9.9-8.49 10 10 0 0 0-7.8 3.8v-14.5h20.35l3.22 5.28z" />
      <path d="M13.79 36.65h17.06a1.56 1.56 0 1 0 0-3.13H13.78a1.56 1.56 0 1 0 0 3.13m9.2 18.8c0-.86-.7-1.56-1.56-1.56h-8a1.56 1.56 0 1 0 0 3.12h8c.86 0 1.56-.7 1.56-1.56m6.59-10.18c0-.87-.7-1.57-1.57-1.57H5.88a1.56 1.56 0 1 0 0 3.13H28c.87 0 1.57-.7 1.57-1.56" />
    </g>
  ),
};
